
import React from "react";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import './DataTable.css';

import { provideGlobalGridOptions } from 'ag-grid-community';

provideGlobalGridOptions({
    theme: "legacy"
})

const DataTable = ({ height, columns, rows, paginationProp, paginationPageSize, onPaginationChanged, paginationPageSizeSelector, rowSelection, isRowSelectable, suppressRowClickSelection, onRowSelected, gridOptions, onGridReady, onSelectionChanged, onRowExpanded, headerCheckboxSelectionFilterOnly, isCellCheckboxSelection, onFirstDataRendered, onCellEditingStarted, onCellEditingStopped, ref, selectionColumnDef, getRowStyle, getRowId, cellEditorParams, stopEditingWhenCellsLoseFocus, onCellValueChanged, onFilterChanged, postFilterChanged, suppressMenuHide, getRowHeight, defaultColDef, enableCharts, cellSelection, getContextMenuItems }) => {
    const containerHeight = gridOptions && gridOptions.domLayout === 'autoHeight' ? 'auto' : (height || 600);

    const handleCellEditingStopped = (params) => {
        try {
            // eslint-disable-next-line no-console
            console.debug('DataTable.onCellEditingStopped', params?.node?.data?.id, params?.colDef?.field, 'oldValue:', params?.oldValue, 'newValue:', params?.newValue);
        } catch (e) {}
        if (typeof onCellEditingStopped === 'function') onCellEditingStopped(params);
    };

    return (
        <div
            className="ag-theme-quartz"
            style={{ height: containerHeight, width: '100%' }}
        >
            <AgGridReact
                ref={ref}
                rowData={rows}
                columnDefs={columns}
                pagination={paginationProp || false}
                // rowModelType={"serverSide"}
                paginationPageSize={paginationPageSize || 10}
                onPaginationChanged={onPaginationChanged}
                paginationPageSizeSelector={paginationPageSizeSelector || [10, 20, 30, 50, 100]}
                rowSelection={rowSelection || "multiple"}
                isRowSelectable={isRowSelectable}
                suppressRowClickSelection={suppressRowClickSelection || true}
                //getRowClass={(param)=>'ag-row-hover'}
                moveColumns={false}
                undoRedoCellEditing={true} // Enable undo/redo for cell editing
                suppressDragLeaveHidesColumns={true}
                suppressMovable={false}
                onRowSelected={onRowSelected}
                gridOptions={gridOptions}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
                onRowExpanded={onRowExpanded}
                onCellEditingStarted={onCellEditingStarted}
                onCellEditingStopped={handleCellEditingStopped}
                headerCheckboxSelectionFilterOnly={headerCheckboxSelectionFilterOnly}
                isCellCheckboxSelection={isCellCheckboxSelection}
                onFirstDataRendered={onFirstDataRendered}
                selectionColumnDef={selectionColumnDef}
                getRowStyle={getRowStyle}
                getRowId={getRowId}
                cellEditorParams={cellEditorParams}
                stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus || true}
                onCellValueChanged={onCellValueChanged}
                onFilterChanged={onFilterChanged}
                postFilterChanged={postFilterChanged}
                suppressMenuHide={suppressMenuHide}
                // enableCellTextSelection={true} 
                getRowHeight={getRowHeight}
                suppressRowTransform={true}
                defaultColDef={defaultColDef}
                enableRangeSelection={true} // Enable range selection
                enableFillHandle={true} // Enable drag fill/copy
                enableCharts={enableCharts || false}
                cellSelection={cellSelection}
                getContextMenuItems={getContextMenuItems}
            />
        </div>
    )
}
export default DataTable

